import { GET_GROUPS_PHASE } from '../types/groups.types';
import { gracenoteApiCall } from './../../api/api';

export const getMundialGroups = (params = {}) => async dispatch => {
  try {
    const { data } = await gracenoteApiCall({
      url: '/leagues/GNA5MGHG2ZVX2RD/standings',
    });
    dispatch({
      type: GET_GROUPS_PHASE,
      payload: data.standings,
    });
  } catch (error) {}
};
